import { render, staticRenderFns } from "./componentSelect.vue?vue&type=template&id=59479c52&scoped=true&"
import script from "./componentSelect.vue?vue&type=script&lang=ts&"
export * from "./componentSelect.vue?vue&type=script&lang=ts&"
import style0 from "./componentSelect.vue?vue&type=style&index=0&id=59479c52&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59479c52",
  null
  
)

export default component.exports